import React from 'react';
import classNames from 'classnames';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import { FDBox, FDPrimaryActionButton } from '@facet-wealth/design';
import fr from 'facet-rest';
import { navigateToPage } from 'Views/Page/Content/Templates';
import useUserContext from 'Context/UserContext';
import Sentry from 'Integrations/Sentry';
import { useSnackbarContext } from 'Context/SnackbarContext';

const useStyles = buildUseStyles('CompleteAnnualReviewButton', (() => ({
  root: {},
})));

const CompleteAnnualReviewButton = ({
  className,
  completed,
  resource,
}) => {
  const classes = useStyles();
  const { isAgent } = useUserContext();
  const { displayErrorMessage } = useSnackbarContext();

  const handleAnnualReviewWizardClick = async () => {
    if (completed) {
      return;
    }

    resource.withRelationship(
      fr.relationships.annualInvestmentReview.name,
      async (rel) => {
        try {
          const [annualInvestmentReviewStep] = await rel.link('related').get();
          navigateToPage(annualInvestmentReviewStep.link('self').url(), isAgent);
        } catch (err) {
          Sentry.createSentryErrorLog(err);
          displayErrorMessage('Error navigating to annual investment review');
        }
      },
      () => {},
    );
  };

  const label = completed ? 'Completed' : 'Complete Review';

  return (
    <FDBox
      className={classNames(classes.root, className)}
    >
      <FDPrimaryActionButton
        test={'complete-air-button'}
        label={label}
        size={'sm'}
        onClick={handleAnnualReviewWizardClick}
      />
    </FDBox>
  );
};

CompleteAnnualReviewButton.defaultProps = {
  className: '',
  completed: false,
};

CompleteAnnualReviewButton.propTypes = {
  className: PropTypes.string,
  completed: PropTypes.bool,
  resource: PropTypes.object.isRequired,
};

export default CompleteAnnualReviewButton;
